import React, { Component } from "react";
import { connect } from "react-redux";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  fetchSocial,
  connectWithInstagram,
  openInstaLoader,
} from "ActionsSocial";
import ContentIcon, { HEADING_SOCIAL } from "ContentIcon";
import NoContent, { NO_SOCIAL_LINK } from "NoContent";
import {
  MAIN_URL,
  INSTAGRAM_CLIENTID,
  COMMON_FAIL_MESSAGE,
  screenHeightLeftFromTop,
} from "Constants";
import AddSocial from "./addsocial.js";
import SocialList from "./social-listing.js";
import InfoTutorial from "InfoTutorial";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Social extends Component {
  constructor(props) {
    super(props);
    this.state = {
      executed: false,
      loading: true,
      desc: LocaleStrings.preparingSocial,
    };
  }

  componentDidMount() {
    if (this.props.contentAvailable) {
      let { session } = this.props;
      // console.log("this.props.history :- ", this.props.history);

      const queryParams = new URLSearchParams(
        this.props.history.location.search
      );
      // console.log("queryParams :- ", queryParams.get("code"));
      var instaToken = queryParams.get("code");
      // console.log("instaToken :- ", instaToken);

      /***** Get token for instagram *****/
      if (instaToken) {
        let body = {
          eventid: session.eventid,
          code: instaToken,
          redirect_uri: `${MAIN_URL}/dashboard/content/social`,
          client_id: INSTAGRAM_CLIENTID,
          login_user_id: session.userid,
        };

        this.props.connectWithInstagram(session, body, (callback) => {
          // console.log("callback :- ", callback);
          // this.props.openInstaLoader(true);
          if (callback.success === 1) {
            setTimeout(() => {
              this.props.fetchSocial(session, (callback) => {
                this.setState({ loading: false });
              });
            }, 100);

            this.props.showSuccess(
              LocaleStrings.social_instagram_media_success
            ); // Success message

            // this.props.openInstaLoader(false);

            this.props.history.push({
              pathname: "/dashboard/content/social",
              search: "",
            });

            // queryParams.delete("code");
            // this.props.history.replace({
            //   search: queryParams.toString(),
            // });
            // console.log("this.props.history inside :- ", this.props.history);
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE); // Error message
            // this.props.openInstaLoader(false);
          }
        });
      } else {
        setTimeout(() => {
          this.props.fetchSocial(session, (callback) => {
            this.setState({ loading: false });
          });
        }, 100);
      }
    } else {
      this.props.history.push("/dashboard/content");
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.contentAvailable !== this.props.contentAvailable) {
      if (nextProps.contentAvailable && !this.state.executed) {
        this.setState({ executed: true });
        setTimeout(() => {
          this.props.fetchSocial(this.props.session, (callback) => {});
        }, 100);
      } else {
        this.props.history.push("/dashboard/content");
      }
    }
  };

  render() {
    let { deviceSize } = this.props;
    var linksAvailable = this.props.socials.length > 0;

    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <ContentIcon heading={HEADING_SOCIAL} />
          </div>
          <div
            className="pull-right h-100 vertical-align-center"
            style={{ marginLeft: "auto" }}
          >
            {/* <AddSocial /> */}
            {/* <InfoTutorial video="" /> */}
          </div>
        </div>
        <div className="clearfix"></div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : linksAvailable ? (
            <SocialList />
          ) : (
            <NoContent contentType={NO_SOCIAL_LINK} />
          )}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  var availableFeatures = state.availableFeatures.filter(
    (feature) => feature.available
  );
  var selectedFeature = availableFeatures.filter(
    (feature) => feature.bsClass === state.selectedContentFeature.bsClass
  );
  var contentAvailable = selectedFeature.length > 0;
  return {
    session: state.session,
    socials: state.socials,
    contentAvailable,
    deviceSize: state.deviceSize,
  };
}
export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchSocial,
  connectWithInstagram,
  openInstaLoader,
})(Social);
